var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download"
  }, /*#__PURE__*/React.createElement("path", {
    id: "download_2",
    d: "M16 21.388L9.92827 15.3163L11.427 13.7738L14.9334 17.2801V5.33334H17.0667V17.2801L20.573 13.7738L22.0718 15.3163L16 21.388ZM7.90429 26.6667C7.18587 26.6667 6.57777 26.4178 6.07999 25.92C5.58221 25.4222 5.33332 24.8141 5.33332 24.0957V20.2393H7.46663V24.0957C7.46663 24.2051 7.51221 24.3054 7.60338 24.3966C7.69457 24.4878 7.79487 24.5334 7.90429 24.5334H24.0958C24.2052 24.5334 24.3055 24.4878 24.3967 24.3966C24.4878 24.3054 24.5334 24.2051 24.5334 24.0957V20.2393H26.6667V24.0957C26.6667 24.8141 26.4178 25.4222 25.9201 25.92C25.4223 26.4178 24.8142 26.6667 24.0958 26.6667H7.90429Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.c74d1fc086fa750a0eccff6c9e73de9b.svg";
export { ForwardRef as ReactComponent };